import { delay } from "../../utils"
import { rest } from "msw"

export const geolocation = [
  rest.get(/\/v1\/geolocation\/cities\/$/, function (_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./fixture.json")))
  }),
]
